import { render, staticRenderFns } from "./RecievedPerDayTable.vue?vue&type=template&id=0ec5113c&"
import script from "./RecievedPerDayTable.vue?vue&type=script&lang=js&"
export * from "./RecievedPerDayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports